import styled from "@emotion/styled";
import React from "react";
import i18n from "src/locales";
import { trackEvent } from "src/utils/api/tracker";
import { useFooterOverride } from "./SingleUseFooter";

const Container = styled.div<{ padding: number }>`
  a {
    color: inherit;
    padding-right: ${({ padding }) => padding}px;

    &:after {
      display: inline-block;
      content: "|";
      padding-left: ${({ padding }) => padding}px;
    }

    &:last-child {
      padding-right: 0px;
      padding-left: 0px;
    }

    &:last-child:after {
      content: "";
      padding-left: 0px;
    }
  }
`;

const PaidTrafficExtraFooterLinks = () => {
  return (
    <>
      <a
        href="https://web.noom.com/about-us/"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent("ClickedAboutUsFooterLink")}
      >
        {i18n.t("footer:aboutUs")}
      </a>
      <a
        href="https://web.noom.com/support/faqs/question-topics/my-account/2021/04/noom-phone-number-and-phone-support/"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent("ClickedContactUsFooterLink")}
      >
        {i18n.t("footer:contactUs")}
      </a>
      <a
        href="https://www.trustpilot.com/review/noom.com"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent("ClickedReviewsFooterLink")}
      >
        {i18n.t("footer:reviews")}
      </a>
    </>
  );
};

export function LegalLinks({
  padding = 10,
  removeSupport,
  className,
  includeExtraFooterLinks,
}: {
  padding?: number;
  removeSupport?: boolean;
  className?: string;
  includeExtraFooterLinks?: boolean;
}) {
  // Caller will have to do override to ensure legal requirements if not including
  // support link.
  useFooterOverride(!removeSupport);

  return (
    <Container padding={padding} className={className}>
      {includeExtraFooterLinks && <PaidTrafficExtraFooterLinks />}
      <a
        href={i18n.t("footer:loginLink")}
        onClick={() => trackEvent("ClickedLoginFooterLink")}
      >
        {i18n.t("footer:login")}
      </a>
      <a
        href={i18n.t("footer:researchPolicyLink")}
        onClick={() => trackEvent("ClickedResearchPolicyFooterLink")}
      >
        {i18n.t("footer:researchPolicy")}
      </a>
      <a
        href={i18n.t("footer:HIPAALink")}
        onClick={() => trackEvent("ClickedHIPAAFooterLink")}
      >
        {i18n.t("footer:HIPAANotice")}
      </a>
      <a
        href={i18n.t("footer:termsAndConditionsLink")}
        onClick={() => trackEvent("ClickedTermsAndConditionsFooterLink")}
      >
        {i18n.t("footer:termsAndConditions")}
      </a>
      <a
        href={i18n.t("footer:privacyPolicyLink")}
        onClick={() => trackEvent("ClickedPrivacyPolicyFooterLink")}
      >
        {i18n.t("footer:privacyPolicy")}
      </a>
      {!removeSupport && (
        <a
          href={i18n.t("footer:customerSupportLink")}
          onClick={() => trackEvent("ClickedSupportFooterLink")}
        >
          {i18n.t("footer:support")}
        </a>
      )}
    </Container>
  );
}
